import React, { createContext, useState, useContext } from 'react';

// 创建Context
const LangContext = createContext();

// 提供者组件
export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('en'); // 默认英文
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

// 自定义hook，方便使用
export const useLang = () => useContext(LangContext);